import React, { useContext, useEffect, useState } from 'react';
import chilankaImg from "../../Assests/mainLogo.png";
import ad from "../../Assests/Bollywood summer camp 2026 details.PNG";
import Classes from "../../components/classesComponent/classesComponent";
import GalleryComponent from "../GalleryComponent/GalleryComponent";
import ContactImg from "../../components/condactForm/contact";
import { contextData } from "../../App";
import { Link } from "react-router-dom";
import roundLogo from "../../Assests/round logo.svg";
import mobileLogo from "../../Assests/Chilanka logo 2.svg";
import YouTubePlayer from "../youtubeComponent/youtube";

// Summer camp promos (the popup flyer on page load + the "Summer Dance Camp" banner above Contact Us).
// Set to true to bring them back for next year's camp (update the dates/flyer first).
const SHOW_SUMMER_CAMP_PROMOS = false;

function Home() {
  const { isScrolled, setIsScrolled } = useContext(contextData);
  const [showPopup, setShowPopup] = useState(SHOW_SUMMER_CAMP_PROMOS);

  useEffect(() => {
    window.scrollTo(0, 0);
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 0);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <div>
      {showPopup && (
<div className="fixed inset-0 bg-black bg-opacity-80 flex justify-center items-center z-50 p-4">
  <div className="shadow-lg text-center max-w-lg w-full max-h-[90vh] overflow-y-auto">
    <img className='rounded-xl w-full' src={ad} alt="" />
    <div className="mt-4 flex flex-col items-center gap-3 bg-black bg-opacity-60 py-4 rounded-3xl">
      <Link to="/eventPage">
        <button className="bg-[#E40F94] text-white px-6 py-2 rounded-md hover:bg-[#c00c7b]">Register Now</button>
      </Link>
      <button onClick={() => setShowPopup(false)} className="text-white bg-gray-700 hover:bg-gray-600 px-6 py-2 rounded-md text-sm tracking-widest uppercase">✕ Close</button>
    </div>
  </div>
</div>
      )}

      <div>

        {/* ── HERO ── */}
        <div className='md:w-full w-full md:px-[282px] px-4 py-12 md:py-[190px] md:h-[752px] bg-bannerImage bg-cover'>
          <div className='bg-black bg-opacity-20 md:px-14 md:py-14 md:flex items-center justify-center hidden md:block rounded-2xl backdrop-blur-sm text-center'>
            <div>
              <img className='mr-[48px]' src={chilankaImg} alt="" />
            </div>
            <div className='text-white drop-shadow-lg text-center'>
              <p className='text-[13px] uppercase tracking-[5px] text-[#E40F94] font-semibold mb-2'>Discover Indian Dancing</p>
            <h1 className='text-[42px] font-bold leading-tight' style={{ fontFamily: 'Playfair Display, serif' }}>
  Move. Inspire. <em style={{ color: '#E40F94' }}>Shine.</em>
</h1>
              <Link to='contact'>
                <div className='inline-block bg-[#E40F94] text-white px-8 py-4 text-[15px] font-semibold rounded-full mt-8 hover:bg-[#c00c7b] transition-colors duration-300 tracking-wide'>
                  Contact Us
                </div>
              </Link>
            </div>
          </div>
          {/* Mobile hero */}
          <div>
            <div className='mx-auto md:hidden flex justify-center mt-[104px]'>
  <div className='bg-pink bg-opacity-50 backdrop-blur-sm rounded-2xl p-4'>
    <img src={mobileLogo} alt="" />
  </div>
</div>
            <div className='bg-black bg-opacity-70 px-[40px] py-14 md:flex text-center items-center md:hidden block mt-10 rounded-2xl backdrop-blur-sm'>
              <div>
                <h1 className='text-white text-[32px] leading-10 tracking-wide font-bold drop-shadow-lg'>Chilanka Dance School</h1>
              </div>
              <div className='text-white mt-10'>
                <h1 className='text-[16px] font-normal leading-4'>Discover Indian Dancing</h1>
                <h1 className='text-[20px] leading-8 font-normal mt-6'>Move. Inspire. <span className='text-[#E40F94]'>Shine.</span></h1>
              </div>
            </div>
          </div>
        </div>

        {/* ── MARQUEE TICKER ── */}
        <div className="bg-[#E40F94] overflow-hidden py-3 whitespace-nowrap">
          <div className="inline-block marquee-animate">
            {[
              'Bharatanatyam', 'Bollywood', 'Bhangra', 'Garba',
              'Classical Indian Dance', 'Pearland, Texas',
              'Bharatanatyam', 'Bollywood', 'Bhangra', 'Garba',
              'Classical Indian Dance', 'Pearland, Texas',
            ].map((item, i) => (
              <span key={i} className="inline-block text-white text-[11px] font-bold tracking-[3px] uppercase px-10">
                {item} <span className="text-pink-200">✦</span>
              </span>
            ))}
          </div>
        </div>

        {/* ── INTRO BLURB ── */}
        <div className='md:px-[176px] md:py-[100px] px-6 py-[72px] bg-white text-center'>
          <p className='text-[13px] uppercase tracking-[5px] text-[#E40F94] font-semibold mb-4'>Welcome</p>
          <p className='md:text-[26px] text-[18px] md:leading-[1.7] leading-8 font-light text-gray-700 max-w-3xl mx-auto'>
            Discover the joy of Indian dance at Chilanka Dance School, where tradition meets passion.<br className='hidden md:block' />
            Led by Director <span className='text-[#E40F94] font-medium'>Jasmin Eapen</span>, we are dedicated to nurturing talent, preserving cultural heritage, and spreading the art of dance.
          </p>
          <div className='w-16 h-[3px] bg-[#E40F94] rounded-full mx-auto mt-10'></div>
          {/* Diamond divider */}
          <div className='flex items-center justify-center gap-4 mt-10'>
            <div className='w-20 h-[1px] bg-[#E40F94]'></div>
            <div className='w-2 h-2 bg-[#E40F94] rotate-45'></div>
            <div className='w-2 h-2 border border-[#E40F94] rotate-45'></div>
            <div className='w-2 h-2 bg-[#E40F94] rotate-45'></div>
            <div className='w-20 h-[1px] bg-[#E40F94]'></div>
          </div>
        </div>

        {/* ── STATS BAND ── */}
        <div className="bg-[#E40F94] py-12 px-6">
          <div className="max-w-4xl mx-auto grid grid-cols-2 md:grid-cols-4 gap-0">
            {[
              { num: '10+', label: 'Years Teaching' },
              { num: '50+', label: 'Students Trained' },
              { num: '2', label: 'Dance Styles' },
              { num: '30+', label: 'Performances' },
            ].map((stat, i) => (
              <div key={i} className={`text-center px-6 py-4 ${i < 3 ? 'border-r border-white/25' : ''}`}>
                <div className="text-white font-bold text-[42px] leading-none" style={{ fontFamily: 'Playfair Display, serif' }}>
                  {stat.num}
                </div>
                <div className="text-pink-100 text-[11px] font-bold tracking-[2px] uppercase mt-2">
                  {stat.label}
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* ── OUR MISSION ── */}
        <div className='bg-banner-image333 bg-cover bg-center relative md:px-[300px] md:py-[120px] px-4 py-20'>
          <div className='absolute inset-0 bg-black bg-opacity-50'></div>
          <div className='relative z-10 flex flex-col items-center text-center'>
            <img className='mx-auto w-[80px] h-[80px] rounded-full border-2 border-white shadow-lg mb-6' src={roundLogo} alt="" />
            <p className='text-[13px] uppercase tracking-[6px] text-[#E40F94] font-semibold mb-3'>What We Stand For</p>
            <p className='text-[40px] md:text-[52px] font-bold text-white leading-tight mb-6' style={{ fontFamily: 'Playfair Display, serif' }}>
  Our <em style={{ color: '#E40F94' }}>Mission</em>
</p>
            <div className='w-16 h-[3px] bg-[#E40F94] rounded-full mb-8'></div>
            <p className='md:text-[22px] text-[16px] leading-9 font-light text-white max-w-2xl mb-12'>To inspire, educate, and empower students through the timeless art of Indian dance.</p>
            <p className='text-[14px] tracking-widest uppercase text-gray-300'>Join us today and experience the rhythm of grace and culture!</p>
          </div>
        </div>

        <Classes />
        <GalleryComponent />
        <YouTubePlayer videoId="SeStVUnI7aY" />

{/* SUMMER CAMP CALLOUT BANNER */}
{SHOW_SUMMER_CAMP_PROMOS && (
<div className='relative text-center overflow-hidden'>

  {/* Floral strip — top */}
  <div className='bg-bannerImage bg-cover bg-center h-24 relative'>
    <div className='absolute inset-0 bg-black bg-opacity-40'></div>
  </div>

  {/* Main dark content area */}
  <div className='relative py-20 px-6 overflow-hidden' style={{ background: 'linear-gradient(135deg, #1A0010 0%, #3D0020 50%, #1A0010 100%)' }}>

    {/* Mandala left */}
    <svg style={{ position: 'absolute', left: '-80px', top: '50%', transform: 'translateY(-50%)', width: '360px', height: '360px', opacity: 0.07, pointerEvents: 'none' }} viewBox="0 0 400 400">
      <g transform="translate(200,200)">
        <circle r="180" fill="none" stroke="#E40F94" strokeWidth="1"/>
        <circle r="140" fill="none" stroke="#E40F94" strokeWidth="0.5"/>
        <circle r="100" fill="none" stroke="#E40F94" strokeWidth="1"/>
        <circle r="60" fill="none" stroke="#E40F94" strokeWidth="0.5"/>
        <ellipse rx="28" ry="76" fill="none" stroke="#E40F94" strokeWidth="0.6" transform="rotate(0)"/>
        <ellipse rx="28" ry="76" fill="none" stroke="#E40F94" strokeWidth="0.6" transform="rotate(30)"/>
        <ellipse rx="28" ry="76" fill="none" stroke="#E40F94" strokeWidth="0.6" transform="rotate(60)"/>
        <ellipse rx="28" ry="76" fill="none" stroke="#E40F94" strokeWidth="0.6" transform="rotate(90)"/>
        <ellipse rx="28" ry="76" fill="none" stroke="#E40F94" strokeWidth="0.6" transform="rotate(120)"/>
        <ellipse rx="28" ry="76" fill="none" stroke="#E40F94" strokeWidth="0.6" transform="rotate(150)"/>
      </g>
    </svg>

    {/* Mandala right */}
    <svg style={{ position: 'absolute', right: '-80px', top: '50%', transform: 'translateY(-50%)', width: '360px', height: '360px', opacity: 0.07, pointerEvents: 'none' }} viewBox="0 0 400 400">
      <g transform="translate(200,200)">
        <circle r="180" fill="none" stroke="#E40F94" strokeWidth="1"/>
        <circle r="140" fill="none" stroke="#E40F94" strokeWidth="0.5"/>
        <circle r="100" fill="none" stroke="#E40F94" strokeWidth="1"/>
        <circle r="60" fill="none" stroke="#E40F94" strokeWidth="0.5"/>
        <ellipse rx="28" ry="76" fill="none" stroke="#E40F94" strokeWidth="0.6" transform="rotate(0)"/>
        <ellipse rx="28" ry="76" fill="none" stroke="#E40F94" strokeWidth="0.6" transform="rotate(30)"/>
        <ellipse rx="28" ry="76" fill="none" stroke="#E40F94" strokeWidth="0.6" transform="rotate(60)"/>
        <ellipse rx="28" ry="76" fill="none" stroke="#E40F94" strokeWidth="0.6" transform="rotate(90)"/>
        <ellipse rx="28" ry="76" fill="none" stroke="#E40F94" strokeWidth="0.6" transform="rotate(120)"/>
        <ellipse rx="28" ry="76" fill="none" stroke="#E40F94" strokeWidth="0.6" transform="rotate(150)"/>
      </g>
    </svg>

    {/* Double inset border */}
    <div className='absolute inset-4 border border-[#E40F94] opacity-20 pointer-events-none'></div>
    <div className='absolute inset-7 border border-[#E40F94] opacity-10 pointer-events-none'></div>

    {/* Content */}
    <div style={{ position: 'relative', zIndex: 2 }}>
      <p className='text-[11px] uppercase tracking-[4px] text-[#FF6DC6] font-bold mb-4'>✦ Limited Spots Available ✦</p>
      <div className='flex items-center justify-center gap-4 mb-6'>
        <div className='w-14 h-[1px] bg-[#E40F94] opacity-50'></div>
        <div className='w-2 h-2 bg-[#E40F94] rotate-45'></div>
        <div className='w-2 h-2 border border-[#E40F94] rotate-45'></div>
        <div className='w-2 h-2 bg-[#E40F94] rotate-45'></div>
        <div className='w-14 h-[1px] bg-[#E40F94] opacity-50'></div>
      </div>
      <h2 className='text-white text-[42px] md:text-[54px] font-bold leading-tight mb-4' style={{ fontFamily: 'Playfair Display, serif' }}>
        Summer Dance Camp <span className='text-[#FF6DC6] italic'>2026</span>
      </h2>
      <p className='text-[#CC88AA] text-[20px] mb-8' style={{ fontFamily: 'Cormorant Garamond, serif' }}>
        June 8 – 12, 2026 · Pearland, Texas
      </p>
      <div className='flex flex-wrap justify-center gap-3 mb-10'>
        {['All Ages Welcome', 'Bollywood & Classical', 'Cultural Celebration', 'Expert Instructors'].map((pill, i) => (
          <span key={i} className='border border-[#E40F94] border-opacity-40 text-[#FF6DC6] text-[10px] font-bold tracking-[2px] uppercase px-4 py-2'>
            {pill}
          </span>
        ))}
      </div>
      <Link to='/eventPage'>
        <div className='inline-block bg-[#E40F94] text-white px-10 py-4 text-[12px] font-bold tracking-[3px] uppercase hover:bg-[#c00c7b] transition-colors duration-300'>
          Register Now
        </div>
      </Link>
    </div>
  </div>

  {/* Floral strip — bottom */}
  <div className='bg-bannerImage bg-cover bg-center h-24 relative'>
    <div className='absolute inset-0 bg-black bg-opacity-40'></div>
  </div>

</div>
)}

        {/* ── JOIN NATYAFUSION CALLOUT ── */}
        <div className='md:px-[192px] px-4 pt-16'>
          <div className='rounded-2xl overflow-hidden shadow-2xl bg-gradient-to-br from-[#1a0010] via-[#3d0228] to-[#E40F94] text-white px-8 md:px-14 py-12 text-center'>
            <p className='text-[12px] uppercase tracking-[5px] font-bold text-pink-200 mb-3'>🏀 Adult Dancers Wanted 🏀</p>
            <h2 className='font-bold text-[30px] md:text-[42px] leading-tight mb-4' style={{ fontFamily: 'Playfair Display, serif' }}>
              Perform at a <em className='text-pink-200'>Houston Rockets</em> Game!
            </h2>
            <p className='text-[16px] md:text-[18px] text-pink-50 max-w-2xl mx-auto mb-8 leading-8'>
              Classically trained and ready to return to the stage? Join NatyaFusion, Chilanka's adult dance team, as we prepare for the Rockets pregame show on February 28, 2027.
            </p>
            <Link to='/natyaFusionPage'>
              <div className='inline-block bg-white text-[#E40F94] px-8 py-4 text-[15px] font-bold rounded-full hover:bg-pink-50 transition-colors duration-300'>
                Join NatyaFusion →
              </div>
            </Link>
          </div>
        </div>

        <ContactImg id="contact"/>

      </div>
    </div>
  );
}

export default Home;
